import PartnerAccessForm from './partner-access-form'

export default PartnerAccessForm
